document.addEventListener("DOMContentLoaded", function () {
  const docsForm = document.getElementById('docsForm');
  if (!docsForm) {
    return;
  }

  const orderRecap = document.getElementById('orderRecap');
  const liberalRadio = document.getElementById("liberalRadio");
  const establishmentRadio = document.getElementById("establishmentRadio");
  const orderButton = document.getElementById("order_button");
  const popupRecap = document.getElementById('popupRecap');
  const quantitySelects = document.querySelectorAll(".selectQTY");

  const radioInputs = document.querySelectorAll('.archiveDocuments__radio-select__radio-label input[type="radio"]');

  // Add click event listeners to each radio input
  radioInputs.forEach(input => {
    input.addEventListener('click', function () {
      // Clear the checked state for all radio labels
      document.querySelectorAll('.archiveDocuments__radio-select__radio-label').forEach(label => {
        label.classList.remove('checked');
      });

      // Add the checked state to the selected radio label
      const label = this.parentElement;
      label.classList.add('checked');
    });
  });

  const documents = [];

  // Disable quantity selection and show message
  // when the select element is clicked before making the first choice
  quantitySelects.forEach((select) => {
    select.addEventListener("click", function () {
      const article = select.closest(".blockDocQty");
      const answerNeededSpan = article.querySelector(".answer-needed");
      answerNeededSpan.style.display = "none";
      if (!liberalRadio.checked && !establishmentRadio.checked) {
        answerNeededSpan.style.display = "block";
      }
    });
  });

  // Order recap close button
  const buttonClose = document.getElementById('buttonClose');
  const cancelOrder = document.getElementById('cancelOrder');
  buttonClose.addEventListener("click", function () {
    popupRecap.style.display = 'none';
  });
  cancelOrder.addEventListener("click", function (e) {
    e.preventDefault();
    popupRecap.style.display = 'none';
  });

  // Function to update the recap based on the documents array
  function updateRecap() {
    let recapContent = '';
    documents.forEach(function (document) {
      recapContent += `${document.title}: ${document.quantity} selected<br>`;
    });
    orderRecap.innerHTML = recapContent;
  }

  // Show the order button if at least one document input is selected
  quantitySelects.forEach((select) => {
    select.addEventListener("change", function () {
      orderButton.style.display = select.value ? "block" : "none";
    });
  });

  // Add a click event listener for the order button
  orderButton.addEventListener("click", function (event) {
    // Handle the order recap
    event.preventDefault();
    popupRecap.style.display = 'block';
  });

  // Function to update the quantity options based on the selected radio button
  function updateQuantityOptions(maxQuantity) {
    quantitySelects.forEach(function (select) {
      select.innerHTML = "<option value=''>Sélectionnez la quantité</option>";
      for (let i = 1; i <= maxQuantity; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = i;
        select.appendChild(option);
      }
    });
  }

  // Event listener for the "Libéral" or "Établissement de santé" radio buttons
  liberalRadio.addEventListener("change", function () {
    orderButton.style.display = "none";
    updateQuantityOptions(5);
    updateRecap();
  });

  establishmentRadio.addEventListener("change", function () {
    orderButton.style.display = "none";
    updateQuantityOptions(10);
    updateRecap();
  });

  // Event listeners for the quantity selectors
  quantitySelects.forEach(function (select) {
    select.addEventListener('change', function () {
      const documentTitle = select.getAttribute('data-doctitle');
      const selectedQuantity = select.value;
      const docId = select.getAttribute('data-id');

      let document = documents.find(doc => doc.docid === docId);
      if (!document) {
        document = { title: documentTitle, quantity: 0 };
        documents.push(document);
      }

      document.title = documentTitle;
      document.quantity = selectedQuantity;
      document.docid = docId;
      updateRecap();
    });
  });

  // Function to generate an editable recap
  function generateEditableRecap() {
    let recapContent = '';
    documents.forEach(function (document) {
      recapContent += `
        <div class="orderRecap__recap__order__doc">
          ${document.title}
          <select name="quantity" class="editable-quantity" data-title="${document.title}" 
            min="1" max="${liberalRadio.checked ? 5 : 10}" data-id="${document.docid}">
            <option value="${document.quantity}" data-title="${document.title}">${document.quantity}</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            ${liberalRadio.checked ? '' : `
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
            `}
          </select>
        </div>
      `;
    });
    orderRecap.innerHTML = recapContent;
  }

  // Function to update the document's quantity when the input field changes
  function updatedocumentQuantity(title, quantity, docid) {
    const document = documents.find(p => p.title === title);
    if (document) {
      document.title = title;
      document.quantity = quantity;
      document.docid = docid;
    }
  }

  // Event listener for the order button
  orderButton.addEventListener("click", function (event) {
    event.preventDefault();

    generateEditableRecap();

    const recapSelects = orderRecap.querySelectorAll(".editable-quantity");
    recapSelects.forEach(function (select) {
      select.addEventListener("change", function () {
        let title = select.getAttribute("data-title");
        let quantity = parseInt(select.value, 10);
        let docid = select.getAttribute("data-id");
        updatedocumentQuantity(title, quantity, docid);
      });
    });
  });

  function popupConfirm() {
    const popupConfirm = document.getElementById('popupConfirm');
    popupConfirm.style.display = 'block';

    const closeConfirmation = document.getElementById('closeConfirmation');
    closeConfirmation.addEventListener("click", function () {
      popupConfirm.style.display = 'none';
      location.reload();
    });
  }

  // Event listener for the submit button
  const submitRecapButton = document.getElementById("docsForm");
  submitRecapButton.addEventListener("submit", function (e) {
    e.preventDefault();
    // Handle the submission of the modified recap here
    let documentsOrdered = documents;

    const data = new URLSearchParams();
    for (const pair of new FormData(this)) {
      data.append(pair[0], pair[1]);
    }

    data.set('order_docs_user_email', '');

    // Append the array of documents
    documentsOrdered.forEach((document, index) => {
      data.set('order_documents', (data.get('order_documents') ? data.get('order_documents') + ';\n\n' : '') + `Titre : ${document.title},\nCode du document : ${document.docid},\nQuantité : ${document.quantity}`);
      data.set('order_docs_user_email', (data.get('order_documents') ? data.get('order_docs_user_email') + '\n\n' : '') + `Titre : ${document.title},\nQuantité : ${document.quantity}.`);
    });

    const buttonSubmit = document.getElementById('submitRecap');
    // Show loader animation on the button
    buttonSubmit.classList.add('loading');

    // Send the data to the server using an AJAX request
    fetch(this.getAttribute('action'), {
      method: 'POST',
      body: data,
      headers: {
        // 'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
    })
      .then(response => response.json())
      .then(data => {
        // Hide the loader animation on the button
        buttonSubmit.classList.remove('loading');
        if (data.success) {
          // Handle success
          // Display a confirmation popup
          popupConfirm()
        } else {
          // Handle error
          handleError(data); // Pass the error data to your error handling function
        }
      })
      .catch(error => {
        // Hide the loader animation on the button
        buttonSubmit.classList.remove('loading');
        // Handle fetch error
        console.error('Fetch error:', error);
      });

    // Error handling function
    function handleError(errorData) {
      // Handle the error data as needed (e.g., show an error message to the user)
      console.error('Error data:', errorData);
    }
  });
});